// extracted by mini-css-extract-plugin
module.exports = {"disabledIndices":"disabledIndices__1xbgI","box":"box__1u8Gc","item":"item__M9bdo","none":"none__2ahEi"};